export default {
  cities: 'Cities',
  city: 'City',
  add: 'Add city',
  update: 'Update city',
  details: 'City details'
}
